import { createUseStyles } from 'react-jss'

export default createUseStyles({
  filter: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.16)',
    zIndex: 1,
  },
  modal: {
    width: '100%',
    maxWidth: 700,
    backgroundColor: 'white',
    zIndex: 2,
    boxShadow: '0 3px 6px rgba(0,0,0,0.4)',
    borderRadius: 6,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 10px'
  },
  modalContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 9999999999999999999
  },
  modalHeader: {
    height: 50,
    width: '100%',
    borderBottom: '1px solid rgba(0,0,0,0.4)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 20px',
  },
  modalClose: {
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1)'
    }
  },

  modalBody: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: '30px 30px 0px 30px',
    height: 'calc(100% - 150px)',
    '& input, label': {
      width: '100%',

    },
    '& textarea': {
      maxWidth: '100%',
      resize: 'none',
      width: '100%',
      height: 100,
      border: '2px solid rgba(0,0,0,0.6)',
      padding: 10,
      borderRadius: 6,
      marginBottom: 20,
      transition: '0.3s',
      outline: 'none',
      '&:hover': {
        borderColor: '#004f9f'
      },
      '&:focus': {
        boxShadow: '0 0px 5px #004f9f',
        borderColor: '#004f9f'
      }
    }
  },
  
  modalBottom: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 30,

    "& button": {
      padding: 10,
      border: 'none',
      margin: '0 10px',
      backgroundColor: '#004f9f',
      color: 'white',
      borderRadius: 5,
      cursor: 'pointer',
      outline: 'none',
      '&:hover': {
        boxShadow: '0 3px 6px rgba(0,0,0,0.3)'
      },
      '&:active': {
        boxShadow: '0 3px 6px rgba(0,0,0,0.6)'
      }
    }
  }
})